import { INGXLoggerConfig, INGXLoggerMetadata, NGXLoggerWriterService } from "ngx-logger";
import { logDB } from "../data/logDB";
import { environment } from "src/environments/environment";
import { writeToConsole } from "./writeToConsole";
import { safeStringify, toPlainAdditional } from "./logSerialize";



export class DBLogger extends NGXLoggerWriterService {
  constructor(
  ) {
    super(1);
  }

  override writeMessage(metadata: INGXLoggerMetadata, config: INGXLoggerConfig): void {
    // Snimanje u lokalnu bazu (svi nivoi). `catch` je obavezan: upis loga ne sme ni da
    // obori aplikaciju ni da proizvede novu unhandled rejection (koju bi globalni
    // handler opet logovao — petlja).
    logDB.logs.add({
      timestamp: metadata.timestamp!,
      // logger.debug(objekat) bez teksta — objekat odmah u JSON, umesto kasnijeg
      // "[object Object]" u poslatom fajlu.
      message: typeof metadata.message === 'string' ? metadata.message : safeStringify(metadata.message),
      level: metadata.level,
      // Error → {name, message, stack} već pri upisu — sirov Error se pri slanju
      // stringify-uje u "{}" pa stack trace nikad ne bi stigao na server.
      additional: toPlainAdditional(metadata.additional),
    }).catch(() => { /* quota/clone problem — zapis se preskače */ });

    // Konzola: normalne poruke rutirane po nivou (greške kao console.error), samo van produkcije.
    if (!environment.production) {
      writeToConsole(metadata);
    }
  }
}
